import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import DialogRef from './common/DialogRef';
import { act, ReactNode, use, useEffect, useState } from 'react';
import { AnimatedButton } from './common/AnimatedButton';
import DynamicImage from './DynamicImage';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useToast } from '@/hooks/use-toast';
import { getParams2Object, goLogin } from '@/utils';
import { anyRequest } from '@/utils/fetch';
const RegisDialog = ({
  children,
  open = false,
  changeActive,
}: {
  children: ReactNode;
  open?: boolean;
  changeActive: Number;
}) => {
  const [active, setActive] = useState(0);
  const [checked, isChecked] = useState(false);
  const [authDialog, setAuthDialog] = useState(false);
  const [phone, setPhone] = useState({
    value: '',
    rules: '请输入手机号',
    placeholder: '手机号',
    type: 'number',
    isWarn: false,
  });
  const [corpName, setCorpName] = useState({
    value: '',
    rules: '请输入企业全称',
    placeholder: '企业全称',
    type: 'text',
    isWarn: false,
  });
  const [regisOpen, setRegisOpen] = useState(open);
  const { toast } = useToast();
  const [isShow, SetIsShow] = useState(false);
  useEffect(() => {
    setActive(0);
    setPhone({ ...phone, value: '' });
    setCorpName({ ...corpName, value: '' });
    isChecked(false);
  }, [changeActive]);
  const nextStep = () => {
    if (!phone.value) {
      setPhone({ ...phone, isWarn: true });
      return;
    }
    if (!corpName.value) {
      setCorpName({ ...corpName, isWarn: true });
      return;
    }
    if (!checked) {
      // toast({
      //   title: '请勾选下方协议',
      // });
      SetIsShow(true);
      return;
    }
    anyRequest({
      url: `${process.env.NEXT_PUBLIC_ADMIN_URL}/api/auth/oauth/buildWxAuthorizeUrl`,
      params: {
        key: phone.value,
        type: false,
      },
      method: 'GET',
      callback: resp => {
        setActive(1);
        setAuthDialog(true);
        window.open(resp.data);
      },
    });
  };

  return (
    <>
      <DialogRef
        open={regisOpen}
        title={'注册微友智汇'}
        trigger={children}
        contentClass="w-[491px] bg-white rounded-[10px] justify-center"
        footer={
          active ? (
            <div className="flex flex-col items-center gap-y-3 mt-6">
              <button
                onClick={() => nextStep()}
                className="w-[256px] gap-1 h-8 flex items-center justify-center rounded-sm border bg-themeColor text-sm text-white"
              >
                <DynamicImage src="/images/icon/wyzhLogo.png" width={14} height={14}></DynamicImage>
                <span>去微友智汇授权</span>
              </button>
              <p className="text-xs text-black/45">或</p>
              <button
                onClick={() => window.open('https://work.weixin.qq.com/')}
                className="border gap-1 border-[#0082EF] w-[256px] h-8 flex items-center justify-center rounded-sm bg-white shadow-sm text-sm text-[#0082EF]"
              >
                <DynamicImage
                  src="https://osscdn.weiyouzhihui.com/staticIcon/home/qwLogo.png"
                  width={14}
                  height={14}
                ></DynamicImage>
                <span>注册企业微信</span>
              </button>
            </div>
          ) : (
            <div className="mt-12 w-[256px]">
              <AnimatedButton
                onClick={() => nextStep()}
                className="border text-white h-9 bg-themeColor text-base flex items-center justify-center border-[#FF6700] rounded-sm w-full"
              >
                下一步
              </AnimatedButton>
              <p className="mt-3 text-black/45 text-xs text-center">
                微友智汇不会将你的任何数据透露给第三方
              </p>
              <div className="flex items-center gap-1 mt-3">
                <div
                  onClick={() => {
                    SetIsShow(false);
                    isChecked(!checked);
                  }}
                >
                  {checked ? (
                    <DynamicImage
                      src="/images/icon/cycleCheck.png"
                      width={14}
                      height={14}
                    ></DynamicImage>
                  ) : (
                    <div className="w-[14px] h-[14px] rounded-[2px] border border-[#d9d9d9]"></div>
                  )}
                </div>
                <span className="text-black/45 text-xs">
                  同意微友智汇
                  <span
                    className="text-[#ff6700]"
                    onClick={() =>
                      window.open(`${process.env.NEXT_PUBLIC_MALL_GZH}/pages/user_center/userAgreement?noAuth=1`, '_blank')
                    }
                  >
                    《隐私协议》
                  </span>
                  和
                  <span
                    className="text-[#ff6700]"
                    onClick={() =>
                      window.open(`${process.env.NEXT_PUBLIC_MALL_GZH}/pages/user_center/privacyPolicy?noAuth=1`, '_blank')
                    }
                  >
                    《用户协议》
                  </span>
                </span>
              </div>
              {isShow && <p className="text-[#ff6700] text-xs text-center mt-3">请勾选协议</p>}
            </div>
          )
        }
      >
        <div className="w-[423px] h-[38px] left-[34px] bg-white rounded-[4px] flex items-center justify-center  text-sm text-black/85 absolute -top-16">
          <DynamicImage
            src="/images/icon/!.png"
            width={14}
            height={14}
            className="mr-1.5"
          ></DynamicImage>
          企业注册微友智汇后，员工可直接登录，无需注册{' '}
          <span className="text-themeColor ml-1.5" onClick={() => goLogin()}>
            点击登录
          </span>
        </div>
        <div className="mt-10 flex items-center gap-3 justify-center">
          <div className="flex items-center gap-2">
            {active ? (
              <DynamicImage src="/images/icon/check.png" width={24} height={24}></DynamicImage>
            ) : (
              <div className="bg-themeColor rounded-full text-base leading-5 text-white w-6 h-6 flex justify-center border border-themeColor">
                1
              </div>
            )}
            <span className="text-base text-black/85">填写信息</span>
          </div>

          <div className={`w-20 h-px ${active ? 'bg-themeColor' : 'bg-[#f0f0f0]'}`}></div>
          <div className="flex items-center gap-2">
            <div
              className={`rounded-full text-base w-6 h-6 flex justify-center leading-5 border ${active ? 'text-white bg-themeColor border-themeColor' : 'text-black/25 bg-white border-black/25'}`}
            >
              2
            </div>
            <span className="text-base text-black/85">授权给微友智汇</span>
          </div>
        </div>
        {active ? (
          <>
            <div className="flex items-center mt-7 gap-x-[22px] justify-center">
              <DynamicImage src="/images/icon/wyzh.png" width={103} height={27}></DynamicImage>
              <DynamicImage src="/images/icon/x.png" width={24} height={24}></DynamicImage>
              <DynamicImage src="/images/icon/qywx.png" width={100} height={27}></DynamicImage>
            </div>
            <div className="bg-[#FFF6F0] border-themeColor flex-col align-baseline border rounded-md mt-7 flex items-baseline justify-center p-6">
              <div className="flex items-center gap-2 text-black/85 text-sm">
                <div className="w-1 h-1 bg-themeColor rounded-full"></div>
                注册微友智汇需要【授权给微友智汇】来进行企业验证
              </div>
              <div className="flex items-center gap-2 text-black/85 text-sm mt-4">
                <div className="w-1 h-1 bg-themeColor rounded-full"></div>
                未注册企业微信的用户请先注册企业微信
              </div>
            </div>
          </>
        ) : (
          <div className="grid gap-4 py-4">
            <div>
              <Label htmlFor="name" className="text-left">
                <span className="text-red-600">*</span>
                {phone.rules}
              </Label>
              <Input
                id="phone"
                type="number"
                maxLength={11}
                value={phone.value}
                onChange={e => setPhone({ ...phone, value: e.target.value })}
                autoComplete="off"
                className={`col-span-3 mt-1 placeholder:text-gray-400 ${phone.isWarn ? 'border-red-600' : 'border-gray-400'}`}
                placeholder={phone.placeholder}
              />
              {phone.isWarn && <p className="text-red-600 text-sm mt-1">{phone.rules}</p>}
            </div>
            <div>
              <Label htmlFor="phone" className="text-left mt-4">
                <span className="text-red-600">*</span>
                {corpName.rules}
              </Label>
              <Input
                type={corpName.type}
                id="username"
                value={corpName.value}
                onChange={e => setCorpName({ ...corpName, value: e.target.value })}
                autoComplete="off"
                className={`col-span-3 mt-1 placeholder:text-gray-400 ${corpName.isWarn ? 'border-red-600' : 'border-gray-400'}`}
                placeholder={corpName.placeholder}
              />
              {corpName.isWarn && <p className="text-red-600 text-sm mt-1">{corpName.rules}</p>}
            </div>
          </div>
        )}
      </DialogRef>
      <AlertDialog open={authDialog}>
        <AlertDialogContent className="bg-white rounded-[10px]">
          <AlertDialogHeader>
            <AlertDialogTitle>
              <div className="flex items-center w-full">
                <span>授权中</span>
                <DynamicImage
                  className="ml-auto"
                  src="/images/icon/x.png"
                  width={16}
                  height={16}
                  onClick={() => setAuthDialog(false)}
                ></DynamicImage>
              </div>
            </AlertDialogTitle>
            <AlertDialogDescription>请在新窗口完成企业微信授权</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AnimatedButton
              className="bg-white border border-[#d9d9d9] rounded-sm flex justify-center items-center text-sm text-black/85 w-[88px] h-[32px]"
              onClick={() => nextStep()}
            >
              重新授权
            </AnimatedButton>
            <AnimatedButton
              className="bg-themeColor border border-themeColor rounded-sm flex justify-center items-center text-sm text-white w-[88px] h-[32px]"
              onClick={() => goLogin()}
            >
              我已授权
            </AnimatedButton>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default RegisDialog;
